import React from 'react'
// import { numberThumbnail } from 'src/helper/tool'

import './index.less'
import { isRtl } from 'src/helper/tool'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  getRank = (rankIdx) => {
    if (rankIdx === 0) {
      return '20+'
    }

    return rankIdx
  }

  render() {
    const { countryMine, rankingMine, index, language } = this.props
    return (
      <div className="fixed-wrap">
        <div className={`fixed-contant ${index === 1 ? 'ranking' : ''} ${isRtl(language) ? 'arlang' : ''}`}>
          <div className="number-wrap">
            {this.getRank(index === 1 ? rankingMine.rankIdx : countryMine.rankIdx)}
          </div>
          <div className="card-wrap">
            <div className="img-wrap">
              <img src={index === 1 ? rankingMine.avatarurl : countryMine.countryIcon} />
            </div>
            <div className="text-wrap">
              <p className="name">
                {index === 1 ? rankingMine.nickname : countryMine.countryName}
              </p>
              {
                index !== 1 && (
                  <div className="avatar-warp">
                    {
                      countryMine.avatarurlList && countryMine.avatarurlList.map((avatar) => {
                        return (
                          <div className="avatar-item" key={avatar}>
                            <img src={avatar} />
                          </div>
                        )
                      })
                    }
                  </div>
                )
              }
              {/* 排名tab激活显示ID */}
              {
                index === 1 && (
                  <p className='id'>ID: {rankingMine.duid}</p>
                )
              }
            </div>
          </div>
          <div className="price-wrap">
            <div className="icon-wrap">
              <img src={index === 1 ? rankingMine.giftIcon : countryMine.giftIcon} />
            </div>
            {
              index === 1 ? rankingMine.score : countryMine.score
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/fixed-card/index.js